import { renderDataCentreBlocks } from '../../util/BlockUtil';

const Region = ({
  data,
  metros,
  lang,
  width,
  popular_downloads_posts,
  related_content,
  tags,
  global,
  dataCenters,
}) => {
  return (
    <div className="region-template">
      {renderDataCentreBlocks({
        data,
        metros,
        global,
        lang,
        width,
        popular_downloads_posts,
        related_content,
        tags,
        dataCenters,
      })}
    </div>
  );
};
export default Region;
